<template>
  <v-tooltip bottom :open-delay="150" max-width="320">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        x-small
        type="button"
        class="relationship-field-help"
        :aria-label="`About ${label}`"
        :aria-describedby="helpId">
        <v-icon x-small aria-hidden="true">mdi-information-outline</v-icon>
        <span :id="helpId" class="relationship-field-help__sr-only">{{ text }}</span>
      </v-btn>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
let helpSequence = 0;

export default {
  name: 'RelationshipFieldHelp',
  props: {
    label: { type: String, required: true },
    text: { type: String, required: true },
  },
  data() {
    helpSequence += 1;
    return { helpId: `relationship-field-help-${helpSequence}` };
  },
};
</script>

<style lang="scss" scoped>
.relationship-field-help {
  width: 24px;
  min-width: 24px !important;
  height: 24px;
  flex: 0 0 24px;
  margin-left: var(--ds-space-xs);
  color: var(--v-blue-base);
}

.relationship-field-help:focus-visible {
  outline: var(--ds-focus-ring-width, 2px) solid var(--v-primary-base);
  outline-offset: var(--ds-focus-ring-offset, 2px);
}

.relationship-field-help__sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
  white-space: nowrap;
}
</style>
